import { useQuery } from 'react-query';

import api from '@root/api';

export default function useGetGenerationsUsage() {
  return useQuery(['usage.stats'], () => api.usage.getStats());
}
